import CardStadistics from 'Components/CardStadistics';
import Label from 'Components/Label';
import SelectUsers from 'Components/SelectUsers';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setExpedienteId, setId } from '../../../../redux/slices';
import EstadisticasService from 'Services/Http/Estadisticas.service';
import { formatCurrency, formatPercentage } from 'Utils/Functions';
import ProgressBar from 'Components/ProgressBar';
import Button from 'Components/Button';
import CreditoService from 'Services/Http/Credito.service';
import ModalComponent from 'Components/Modal';

const ListarCreditoActivo = () => {
  const { pagos } = useSelector((state) => state.session.session);
  const [records, setRecords] = useState([]);
  const [idUser, setIdUser] = useState(null);
  const [loader, setLoader] = useState(false);
  const [estadistica, setEstadistica] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [fnMethod, setFnMethod] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const [typeModal, setTypeModal] = useState('');
  const [messageModal, setMessageModal] = useState('');
  const [idExpediente, setIdExpediente] = useState('');
  const [urlReport, setUrlReport] = useState('');

  useEffect(() => {
    getAllPromotores();
  }, []);

  const changeState = (state) => {
    setShowModal(state);
  };
  const getAllPromotores = async () => {
    setLoader(true);
    try {
      const urlResponse = await EstadisticasService.downloadWallet({ idUser });
      setUrlReport(urlResponse.data);
      const response = await EstadisticasService.activos({ idUser });
      const { records, ...rest } = response.data;
      createRows(records);
      setEstadistica(rest);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const openFile = () => {
    let w = window.open(urlReport, '_blank');
    w.opener = null;
  };

  const activeExpedient = (uuid, id, idExpediente) => {
    if (pagos) {
      const url = '/main/validacion/' + uuid + '/autorizado';
      const dataId = [];
      dataId[uuid] = id;
      dispatch(setId(dataId));
      dispatch(setExpedienteId(idExpediente));
      goTo(url);
    }
  };

  const goTo = (url) => {
    navigate(url);
  };

  const liquidacion = async () => {
    setShowModal(false);
    try {
      await CreditoService.liquidacion(idExpediente);
      setTypeModal('notificacion');
      setMessageModal('Se ha registrado la liquidacion correctamente');
      setStateModal('success');
      setShowModal(true);
      getAllPromotores();
    } catch (e) {
      console.log(e);
      setShowModal(false);
      setTypeModal('notificacion');
      setMessageModal('Ocurrio un error valide e intente de nuevo.');
      setStateModal('succes');
      setShowModal(true);
    }
  };

  const liquidacionModal = (idExpediente) => {
    setFnMethod('liquidacion');
    setIdExpediente(idExpediente);
    setTypeModal('decision');
    setMessageModal('¿Esta seguro que el prestamo ya ha sido liquidado?');
    setStateModal('warning');
    setShowModal(true);
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.id}
        </td>
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.nombreCompleto}
        </td>
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.etiquetaCredito}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.fechaProximoPago}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.pago)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.pagosPendientes}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.atraso}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.totalPagos)}
        </td>
        <td
          className="px-6 py-4 text-red-600 font-bold"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.adeudoVencido)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.faltante)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.montoTotal)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.asignado}
        </td>
        <td className="px-6 py-4">
          {item.faltante <= 0 && item.pagosPendientes < 1 ? (
            <Button label="Liquidar" onClick={() => liquidacionModal(item.idExpediente)} />
          ) : (
            ''
          )}
        </td>
      </tr>
    ));
    setRecords(data);
  };

  const actionOK = async () => {
    switch (fnMethod) {
      case 'liquidacion':
        await liquidacion();
        break;
    }
  };

  useEffect(() => {
    getAllPromotores();
  }, [idUser]);

  return (
    <>
      <Label text={'Estadisticas creditos activos'} />
      {pagos ? (
        <div className="flex flex-row my-5 lg:w-2/5 md:w-100 justify-stretch">
          <SelectUsers onChange={setIdUser} />
          <Button iconprefix={['fa', 'download']} onClick={() => openFile()} />
        </div>
      ) : (
        ''
      )}
      <div className="flex flex-col grid lg:grid-cols-4 md:grid-cols-2 gap-3 my-3 justify-stretch">
        <CardStadistics title={'Creditos'} texto={estadistica.creditos || 0} />
        <CardStadistics title={'Clientes'} texto={estadistica.clientes || 0} />
        <CardStadistics title={'Creditos en mora'} texto={estadistica.creditosMora || 0} />
      </div>
      <div className="flex flex-col grid lg:grid-cols-4 md:grid-cols-2 gap-3 my-3 justify-stretch">
        <CardStadistics title={'Cartera Total'} texto={formatCurrency(estadistica.cartera || 0)} />
        <CardStadistics
          title={'Monto cartera sana'}
          texto={formatCurrency(estadistica.sana || 0)}
        />
        <CardStadistics title={'Monto en mora'} texto={formatCurrency(estadistica.mora || 0)} />
        <CardStadistics
          title={'Porcentaje de mora'}
          texto={formatPercentage(estadistica.porcentaje || 0)}
        />
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha de pago
              </th>
              <th scope="col" className="px-6 py-3">
                Pago
              </th>
              <th scope="col" className="px-6 py-3">
                Pagos restantes
              </th>
              <th scope="col" className="px-6 py-3">
                Dias de atraso
              </th>
              <th scope="col" className="px-6 py-3">
                Pagado
              </th>
              <th scope="col" className="px-6 py-3">
                Adeudo Vencido
              </th>
              <th scope="col" className="px-6 py-3">
                Adeudo Total
              </th>
              <th scope="col" className="px-6 py-3">
                Total de Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Asignado
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>{records}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
      <ModalComponent
        show={showModal}
        changeState={changeState}
        typeModal={typeModal}
        title={messageModal}
        stateModal={stateModal}
        actionOK={actionOK}
      />
    </>
  );
};

export default ListarCreditoActivo;
